import { useState } from "react";
import { useLocation } from "react-router-dom";
import { X, Sparkles } from "lucide-react";

const KEY = "mm_promo_banner_closed";

export default function PromoBanner() {
  const { pathname } = useLocation();
  const [closed, setClosed] = useState(() => localStorage.getItem(KEY) === "1");
  if (closed || pathname.startsWith("/admin")) return null;

  const goNewsletter = (e) => {
    e.preventDefault();
    document.getElementById("newsletter")?.scrollIntoView({ behavior: "smooth", block: "center" });
    setTimeout(() => document.querySelector("[data-testid='newsletter-email-input']")?.focus({ preventScroll: true }), 600);
  };

  return (
    <div className="relative z-50 bg-[#78353A] text-[#FAF9F6]" data-testid="promo-banner">
      <div className="max-w-7xl mx-auto px-10 sm:px-12 py-2 text-center text-sm leading-snug">
        <Sparkles className="inline w-4 h-4 mr-1 -mt-0.5 text-[#FADADD]" aria-hidden="true" />
        <span className="font-cursive text-lg sm:text-xl text-[#FADADD]">-10 % sur ta première commande</span>
        <span className="mx-2 hidden sm:inline">·</span>
        <span className="block sm:inline">
          Rejoins{" "}
          <a href="#newsletter" onClick={goNewsletter} className="underline decoration-dotted underline-offset-4 hover:text-[#FADADD]" data-testid="promo-banner-link">
            les potes qui papotent
          </a>{" "}
          et reçois ton code par e-mail ✿
        </span>
      </div>
      <button
        onClick={() => { localStorage.setItem(KEY, "1"); setClosed(true); }}
        className="absolute right-2 top-1/2 -translate-y-1/2 p-2 rounded-full hover:bg-white/15"
        aria-label="Fermer"
        data-testid="promo-banner-close"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
